import React, { useEffect, useState } from 'react';
import { Form, Col, Row, notification, Drawer, Spin } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useNavigate } from 'react-router-dom';
import DF from 'DisplayFramework';
import { useGetThirdPartyDetail } from './useGetThirdPartyDetail';
import SpouseCard from './Components/SpouseCard';
import IncomeCard from './Components/IncomeCard';
import BankAccountCard from './Components/BankAccountCard/BankAccountCard';
import ContactCard from './Components/ContactCard';
import GeneralDataCard from './Components/GeneralDataCard';
import AdditionalInfoCard from './Components/AdditionalInfoCard';
import CorrespondantsCard from './Components/CorrespondantsCard/CorrespondantsCard';
import FinStatementCard from './Components/FinStatementCard/FinStatementCard';
import RolesCard from './Components/RolesCard/RolesCard';
import StatusCard from './Components/StatusCard/StatusCard';
import DocList from '../../Document/DocList';
import TasksListPopover from '../../workflow/TasksListPopover';
import CommList from '../../Print/CommList';
import { ArrowLeftOutlined } from '@ant-design/icons';

import {
  createThirdParty,
  EntityAdditionalAttributeRequest,
  ThirdPartyRequest,
  ThirdPartyResponse,
  updateThirdParty,
  ViewEntityAddAttributeResponse,
} from '../../../services/thirdParty';
import SaveButton from 'components/SaveButton';
import Button from 'components/Button';
import Title from 'components/Title';
import WizardTabs from 'components/WizardTabs';
import { useParams } from 'react-router-dom';
import { ThirdPartyForProposalType } from 'components/ThirdPartyInput';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import Flows from './Components/Flows';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { ReadOutlined } from '@ant-design/icons';
import IActions from 'icons/IActions';
import IMail from 'icons/IMail';
import SynthesList from 'pages/Configuration/ParSynthesObject/SynthesList';
import { useQuery } from 'react-query';
import { getMyWizards } from 'services/workflow';
import AddressCard from './Components/AddressesCard/AddressCard';
import RelationShipListCard from './Components/RelationShipListCard';
import TPProcessFollowUp from './Components/TPProcessFollowup';
import IPaymentschedule from 'icons/IPaymentschedule';
import { isBoolean, isNaN, isNil, isNumber } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { useAttributeContextFramework } from 'DisplayFramework/hooks/useAttribute';
import moment from 'moment';
import TabTPAuthorization from './Components/TabTPAuthorization';
import CurrentStatusCard from './Components/CurrentStatusCard/CurrentStatusCard';

export type ThirdPartyDetailProps = {
  tpId?: string;
  phase?: 'LEAD' | 'TP';
  taskid?: number;
  isProposalCreate?: boolean;
  iscreate?: boolean;
  setThirdPartyForProposal?: (
    ThirdPartyForProposal: ThirdPartyForProposalType
  ) => void;
  hideThirdPartyModal?: () => void;
  hideThirdPartySearchModal?: () => void;
  showAsModal?: boolean;
  onSelect?: (item: ThirdPartyResponse) => void;
  setisvisible?: any;
  isModal?: boolean;
};

const ThirdPartyDetail = (props: ThirdPartyDetailProps) => {
  let { id, phase } = useParams<{ id: string; phase: 'LEAD' | 'TP' }>();
  const {
    taskid,
    isProposalCreate,
    iscreate,
    setThirdPartyForProposal,
    hideThirdPartyModal,
    hideThirdPartySearchModal,
    showAsModal,
    onSelect,
    setisvisible,
    isModal,
  } = props;
  const [tptype, settptype] = useState<string>('');

  const [visible, setVisible] = useState(false);
  const [refetech, setrefetech] = useState(false);

  const closeSynthes = () => {
    setVisible(false);
  };

  const { data: attlist } = useAttributeContextFramework(
    'THIRDPARTY',
    'THIRDPARTY',
    tptype,
    '',
    '',
    '',
    ''
  );

  const getId = () => {
    return props.tpId ? (props.tpId === '0' ? undefined : props.tpId) : id;
  };
  const getPhase = () => {
    return props.phase ? props.phase : phase;
  };
  id = getId() as any;
  phase = getPhase();
  const [form] = useForm();
  const navigate = useNavigate();

  const tabPosition = localStorage.getItem('tabposition') ?? 'left';

  const { data, refetch, isFetching } = useGetThirdPartyDetail(
    isNaN(Number(id)) ? undefined : Number(id),
    phase
  );

  const { data: wizData } = useQuery(['getMyWizards', 'THIRDPARTY'], () =>
    getMyWizards({ entity: 'THIRDPARTY' }).then((res) => res.data)
  );

  var thirdParty = data;
  const [visibleComm, setVisibleComm] = useState(false);
  const [visible360, setVisible360] = useState(false);
  useEffect(() => {
    if (thirdParty) {
      settptype(thirdParty?.generalData?.tptype);
      form.setFieldsValue({
        tpclass: thirdParty?.generalData?.tpclass,
        tpclasslabel: thirdParty?.generalData?.tpclasslabel,
        tpclassdate: thirdParty?.generalData?.tpclassdate,
        tprevenue: thirdParty?.generalData?.tprevenue,
        tprevenuereferenceyear: toDatePickerDate(
          thirdParty?.generalData?.tprevenuereferenceyear
        ),
        tpidentitycardcountry: thirdParty?.generalData?.tpidentitycardcountry,
        tpidentitycardexpirationdate: toDatePickerDate(
          thirdParty?.generalData?.tpidentitycardexpirationdate
        ),
        tpactivitysector: thirdParty?.generalData?.tpactivitysector,
        tpflagresident: thirdParty?.generalData?.tpflagresident,
        tpcategory: thirdParty?.generalData?.tpcategory,
        tpcompanysize: thirdParty?.generalData?.tpcompanysize,
        tpparentcompanyid: thirdParty?.additionalInfo?.tpparentcompanyid,
        tpparentcompanyname: thirdParty?.generalData?.tpparentcompanyname,
        tpfree1: thirdParty?.additionalInfo?.tpfree1,
        tpfree2: thirdParty?.additionalInfo?.tpfree2,
        tpfree3: thirdParty?.additionalInfo?.tpfree3,
        tpfree4: thirdParty?.additionalInfo?.tpfree4,
        tpfree5: thirdParty?.additionalInfo?.tpfree5,
        tpdescription: thirdParty?.additionalInfo?.tpdescription,
        tpid: thirdParty?.generalData?.tpid,
        currcode: thirdParty?.generalData?.currcode,
        tpreference: thirdParty?.generalData?.tpreference,
        tptype: thirdParty?.generalData?.tptype,
        tptypelabel: thirdParty?.generalData?.tptypelabel,

        tpkycstatuslabel: thirdParty?.generalData?.tpkycstatuslabel,
        tpkycstatus: thirdParty?.generalData?.tpkycstatus,
        tpkycdate: thirdParty?.generalData?.tpkycdate?.substring(0, 10),
        tpstatuslabel: thirdParty?.generalData?.tpstatuslabel,
        tpstatusdate: thirdParty?.generalData?.tpstatusdate?.substring(0, 10),
        tpstatuslabelgeneraldata:
          thirdParty?.generalData?.tpstatuslabel +
          ' (' +
          thirdParty?.generalData?.tpstatusdate?.substring(0, 10) +
          ')',
        tpbrokerid: thirdParty?.generalData?.tpbrokerid,
        tplegalform: thirdParty?.generalData?.tplegalform,
        tpname: thirdParty?.generalData?.tpname,
        tpsurname: thirdParty?.generalData?.tpsurname,
        tpmiddlename: thirdParty?.generalData?.tpmiddlename,
        tpmaidenname: thirdParty?.generalData?.tpmaidenname,
        tpmarketingname: thirdParty?.generalData?.tpmarketingname,
        tpmanagername: thirdParty?.generalData?.tpmanagername,
        tpmanagerposition: thirdParty?.generalData?.tpmanagerposition,
        tpactivity: thirdParty?.generalData?.tpactivity,
        tpbranchid: thirdParty?.generalData?.tpbranchid,
        mgid: thirdParty?.generalData?.mgid,
        lancode: thirdParty?.generalData?.lancode,
        countcode: thirdParty?.generalData?.countcode,
        tpcompanycreationdate: toDatePickerDate(
          thirdParty?.generalData?.tpcompanycreationdate
        ),
        tpflagvatexemption: thirdParty?.generalData?.tpflagvatexemption,
        tpvatexemtionenddate: toDatePickerDate(
          thirdParty?.generalData?.tpvatexemtionenddate
        ),
        tpfiscalid: thirdParty?.generalData?.tpfiscalid,
        tpfiscalcity: thirdParty?.generalData?.tpfiscalcity,
        tptaxid: thirdParty?.generalData?.tptaxid,
        tpsalutationcode: thirdParty?.generalData?.tpsalutationcode,
        tpgender: thirdParty?.generalData?.tpgender,
        tpbirthdate: toDatePickerDate(thirdParty?.generalData?.tpbirthdate),
        tpbirthcity: thirdParty?.generalData?.tpbirthcity,
        tpbirthcountry: thirdParty?.generalData?.tpbirthcountry,
        tpprofession: thirdParty?.generalData?.tpprofession,
        tpidentitycardtype: thirdParty?.generalData?.tpidentitycardtype,
        tpidentitycardid: thirdParty?.generalData?.tpidentitycardid,
        tpmaritalstatus: thirdParty?.generalData?.tpmaritalstatus,
        tpnbofchildren: thirdParty?.generalData?.tpnbofchildren,
        tpworkingctdate: toDatePickerDate(
          thirdParty?.generalData?.tpworkingctdate
        ),
        tpworkingcttype: thirdParty?.generalData?.tpworkingcttype,
        tporigin: thirdParty?.generalData?.tporigin,
        tpspecialtag: thirdParty?.generalData?.tpspecialtag,

        parentCompany: {
          tpid: thirdParty?.generalData?.tpparentcompanyid,
          tpname: thirdParty?.generalData?.tpparentcompanyidname,
          tpreference: thirdParty?.generalData?.tpparentcompanyidreference,
        },
        tptradingid: thirdParty?.generalData?.tptradingid,
        tpcompanyid: thirdParty?.generalData?.tpcompanyid,

        tpparentcompanyidreference:
          thirdParty?.generalData?.tpparentcompanyidreference,
        tpparentcompanyidname: thirdParty?.generalData?.tpparentcompanyidname,
        tpcapital: thirdParty?.generalData?.tpcapital,
        tpcapitalholding: Number(thirdParty?.generalData?.tpcapitalholding),
        tppoliticallyexposedperson:
          thirdParty?.generalData?.tppoliticallyexposedperson,
        tpantimoneylaunder: thirdParty?.generalData?.tpantimoneylaunder,
        tpmainadrstreet1: thirdParty?.address?.tpmainadrstreet1,
        tpmainadrstreet2: thirdParty?.address?.tpmainadrstreet2,
        tpmainadrcity: thirdParty?.address?.tpmainadrcity,
        tpmainadrzipcode: thirdParty?.address?.tpmainadrzipcode,
        tpmainadrregion: thirdParty?.address?.tpmainadrregion,
        tpmainadrregionglobale: thirdParty?.address?.tpmainadrregionglobale,
        tpmainadrcountry: thirdParty?.address?.tpmainadrcountry,
        tpsecadrstreet1: thirdParty?.address?.tpsecadrstreet1,
        tpsecadrstreet2: thirdParty?.address?.tpsecadrstreet2,
        tpsecadrcity: thirdParty?.address?.tpsecadrcity,
        tpsecadrzipcode: thirdParty?.address?.tpsecadrzipcode,
        tpsecadrregion: thirdParty?.address?.tpsecadrregion,
        tpsecadrcountry: thirdParty?.address?.tpsecadrcountry,
        bkaccountkeymain: thirdParty?.bankAccount?.bkaccountkey,
        bkaccountnummain: thirdParty?.bankAccount?.bkaccountnum,
        bkbranchcodemain: thirdParty?.bankAccount?.bkbranchcode,
        bkcodemain: thirdParty?.bankAccount?.bkcode,
        bktypemain: thirdParty?.bankAccount?.bktype,
        tpibanmain: thirdParty?.bankAccount?.tpiban,
        tpbicmain: thirdParty?.bankAccount?.tpbic,
        tpbanknamemain: thirdParty?.bankAccount?.tpbankname,
        tpcbtype: thirdParty?.bankAccount?.tpcbtype,
        tpcbnummain: thirdParty?.bankAccount?.tpcbnum,
        tpcbdatemain: thirdParty?.bankAccount?.tpcbdate,
        tpcbkeymain: thirdParty?.bankAccount?.tpcbkey,
        tpcbnamemain: thirdParty?.bankAccount?.tpcbname,
        tptel1: thirdParty?.contact?.tptel1,
        tptelmobile1: thirdParty?.contact?.tptelmobile1,
        tpemail1: thirdParty?.contact?.tpemail1,
        tpcontactname1: thirdParty?.contact?.tpcontactname1,
        tpcontactposition1: thirdParty?.contact?.tpcontactposition1,
        tptel2: thirdParty?.contact?.tptel2,
        tptelmobile2: thirdParty?.contact?.tptelmobile2,
        tpemail2: thirdParty?.contact?.tpemail2,
        tpcontactname2: thirdParty?.contact?.tpcontactname2,
        tpcontactposition2: thirdParty?.contact?.tpcontactposition2,
        tpsaleuserid: thirdParty?.correspondent?.tpsaleuserid,
        tpsaleusername: thirdParty?.correspondent?.tpsaleusername,
        tpsaleuserdate: thirdParty?.correspondent?.tpsaleuserdate?.substring(
          0,
          10
        ),
        tpriskuserid: thirdParty?.correspondent?.tpriskuserid,
        tpriskusername: thirdParty?.correspondent?.tpriskusername,
        tpriskuserdate: thirdParty?.correspondent?.tpriskuserdate?.substring(
          0,
          10
        ),
        tpbouserid: thirdParty?.correspondent?.tpbouserid,
        tpbousername: thirdParty?.correspondent?.tpbousername,
        tpbouserdate: thirdParty?.correspondent?.tpbouserdate?.substring(0, 10),
        tprecuserid: thirdParty?.correspondent?.tprecuserid,
        tprecusername: thirdParty?.correspondent?.tprecusername,
        tprecuserdate: thirdParty?.correspondent?.tprecuserdate?.substring(
          0,
          10
        ),
        tplpuserid: thirdParty?.correspondent?.tplpuserid,
        tplpusername: thirdParty?.correspondent?.tplpusername,
        tplpuserdate: thirdParty?.correspondent?.tplpuserdate?.substring(0, 10),
        tpemployer: thirdParty?.income?.tpemployer,
        tpemployeraddress: thirdParty?.income?.tpemployeraddress,
        tpemloyertel: thirdParty?.income?.tpemloyertel,
        tpmonthlyincome: thirdParty?.income?.tpmonthlyincome,
        tpothersincome: thirdParty?.income?.tpothersincome,
        tpfamilybenefits: thirdParty?.income?.tpfamilybenefits,
        tpothersexpense: thirdParty.income?.tpothersexpense,
        tpotherloan: thirdParty?.income?.tpotherloan,
        tpflagclient: thirdParty?.role?.tpflagclient,
        tpflagsupplier: thirdParty?.role?.tpflagsupplier,
        tpflagguarantor: thirdParty?.role?.tpflagguarantor,
        tproleother: thirdParty?.role?.tproleother,
        tppaymodein: thirdParty?.role?.tppaymodein,
        tppaydelayin: thirdParty?.role?.tppaydelayin,
        tppaymodeout: thirdParty?.role?.tppaymodeout,
        tppaydelayout: thirdParty?.role?.tppaydelayout,
        tplateinterestformula: thirdParty?.role?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          thirdParty.role?.tpblocklateinterestinvoicing,
        tpreminderfeesformula: thirdParty?.role?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          thirdParty?.role?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          thirdParty?.role?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: thirdParty?.role?.tprejectionfeesformula,

        spname: thirdParty?.spouse?.spname,
        spsurname: thirdParty?.spouse?.spsurname,
        spgender: thirdParty?.spouse?.spgender,
        spbirthdate: toDatePickerDate(thirdParty?.spouse?.spbirthdate),
        spbirthcity: thirdParty?.spouse?.spbirthcity,
        spbirthcountry: thirdParty?.spouse?.spbirthcountry,
        spmaidenname: thirdParty?.spouse?.spmaidenname,

        spsalutationcode: thirdParty?.spouse?.spsalutationcode,
        spfiscalid: thirdParty?.spouse?.spfiscalid,
        spprofession: thirdParty?.spouse?.spprofession,
        spidentitycardtype: thirdParty?.spouse?.spidentitycardtype,
        spidentitycardid: thirdParty?.spouse?.spidentitycardid,
        spemployer: thirdParty?.spouse?.spemployer,
        spemployeraddress: thirdParty?.spouse?.spemployeraddress,
        spemloyertel: thirdParty?.spouse?.spemloyertel,
        spmonthlyincome: thirdParty?.spouse?.spmonthlyincome,
        spothersincome: thirdParty?.spouse?.spothersincome,
        spothersexpense: thirdParty?.spouse?.spothersexpense,
        spotherloan: thirdParty?.spouse?.spotherloan,
        tpsalestatuslabel: thirdParty?.status?.tpsalestatuslabel,
        tpsalestatusdate: thirdParty?.status?.tpsalestatusdate?.substring(
          0,
          10
        ),
        tpriskstatuslabel: thirdParty?.status?.tpriskstatuslabel,
        tpriskstatusdate: thirdParty?.status?.tpriskstatusdate?.substring(
          0,
          10
        ),
      });
      if (!isNil(thirdParty?.entityAddAttributList)) {
        let test = {};

        thirdParty?.entityAddAttributList?.forEach(
          (att: ViewEntityAddAttributeResponse) => {
            let value: any;

            if (att.attdatatype === 'STRING') {
              value = att.attstringvalue;
            } else if (att.attdatatype === 'LONG') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'DOUBLE') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'BOOLEAN') {
              value = att.attbooleanvalue;
            } else if (att.attdatatype === 'TEXT') {
              value = att.atttextvalue;
            } else if (att.attdatatype === 'DATE') {
              if (moment(att.attstringvalue, false).isValid()) {
                value = moment(att.attstringvalue, false);
              } else {
                value = null;
              }
            }

            let obj = { [att.attcode]: value };
            test = { ...test, ...obj };
          }
        );
        form.setFieldsValue({ entityAddAttributList: test });
      }
    }
  }, [thirdParty, form]);

  const prepareThirdPartyRequest = (values: any): ThirdPartyRequest => {
    return {
      additionalInfo: {
        tpparentcompanyid: values?.tpparentcompanyid,
        tpparentcompanyname: values?.tpparentcompanyname,
        tpfree1: values?.tpfree1,
        tpfree2: values?.tpfree2,
        tpfree3: values?.tpfree3,
        tpfree4: values?.tpfree4,
        tpfree5: values?.tpfree5,
        tpdescription: values?.tpdescription,
      },
      address: {
        tpmainadrstreet1: values?.tpmainadrstreet1,
        tpmainadrstreet2: values?.tpmainadrstreet2,
        tpmainadrcity: values?.tpmainadrcity,
        tpmainadrzipcode: values?.tpmainadrzipcode,
        tpmainadrregion: values?.tpmainadrregion,
        tpmainadrregionglobale: values?.tpmainadrregionglobale,
        tpmainadrcountry: values?.tpmainadrcountry,
        tpsecadrstreet1: values?.tpsecadrstreet1,
        tpsecadrstreet2: values?.tpsecadrstreet2,
        tpsecadrcity: values?.tpsecadrcity,
        tpsecadrzipcode: values?.tpsecadrzipcode,
        tpsecadrregion: values?.tpsecadrregion,
        tpsecadrcountry: values?.tpsecadrcountry,
      },
      bankAccount: {
        bkaccountkey: values?.bkaccountkeymain,
        bkaccountnum: values?.bkaccountnummain,
        bkbranchcode: values?.bkbranchcodemain,
        bkcode: values?.bkcodemain
          ? values?.bkcodemain
          : form.getFieldValue('bkcodemain'),
        bktype: values?.bktype,
        countcode: values?.countcode,
        tpbkid: values?.tpbkid,
        currcode: values?.currcode,
        tpiban: values?.tpibanmain,
        tpbic: values?.tpbicmain,
        tpbankname: values?.tpbanknamemain,
        tpcbtype: values?.tpcbtype,
        tpcbnum: values?.tpcbnum,
        tpcbdate: values?.tpcbdate,
        tpcbkey: values?.tpcbkey,
        tpcbname: values?.tpcbname,
      },
      contact: {
        tptel1: values?.tptel1?.replace(/\s+/g, ''),
        tptelmobile1: values?.tptelmobile1,
        tpemail1: values?.tpemail1,
        tpcontactname1: values?.tpcontactname1,
        tpcontactposition1: values?.tpcontactposition1,
        tptel2: values?.tptel2,
        tptelmobile2: values?.tptelmobile2,
        tpemail2: values?.tpemail2,
        tpcontactname2: values?.tpcontactname2,
        tpcontactposition2: values?.tpcontactposition2,
      },
      generalData: {
        tpcompanyid: values?.tpcompanyid,
        tptradingid: values?.tptradingid,
        currcode: values?.currcode,
        tpid: values?.tpid,
        tptype: values?.tptype,
        tpbrokerid: values?.tpbrokerid,
        tplegalform: values?.tplegalform,
        tpname: values?.tpname,
        tpsurname: values?.tpsurname,
        tpmiddlename: values?.tpmiddlename,
        tpmaidenname: values?.tpmaidenname,
        tpflagvatexemption: values?.tpflagvatexemption,
        tpvatexemtionenddate: values?.tpvatexemtionenddate,
        tpmarketingname: values?.tpmarketingname,
        tpmanagername: values?.tpmanagername,
        tpmanagerposition: values?.tpmanagerposition,
        tpactivity: values?.tpactivity,
        tpbranchid: values?.tpbranchid,
        lancode: values?.lancode,
        countcode: values?.countcode,
        tpcompanycreationdate: values?.tpcompanycreationdate,
        tpfiscalid: values?.tpfiscalid,
        tpfiscalcity: values?.tpfiscalcity,
        tptaxid: values?.tptaxid,
        tpsalutationcode: values?.tpsalutationcode,
        tpgender: values?.tpgender,
        tpbirthdate: values?.tpbirthdate,
        tpbirthcity: values?.tpbirthcity,
        tpbirthcountry: values?.tpbirthcountry,
        tpprofession: values?.tpprofession,
        tpidentitycardtype: values?.tpidentitycardtype,
        tpidentitycardid: values?.tpidentitycardid,
        tpmaritalstatus: values?.tpmaritalstatus,
        tpnbofchildren: values?.tpnbofchildren,
        tpworkingctdate: dateToString(values?.tpworkingctdate),
        tpworkingcttype: values?.tpworkingcttype,
        tpcapital: values?.tpcapital,
        tpcapitalholding: values?.tpcapitalholding,
        tpkycstatus: values?.tpkycstatus,
        tppoliticallyexposedperson: values?.tppoliticallyexposedperson,
        tpantimoneylaunder: values?.tpantimoneylaunder,
        tporigin: values?.tporigin,
        tpspecialtag: values?.tpspecialtag,
        tpparentcompanyid: values?.parentCompany?.tpid,
        last_action: Number(getId())
          ? wizData?.taskidUpdate
          : wizData?.taskidCreate,
        tpflagresident: values?.tpflagresident,
        tpcategory: values?.tpcategory,
        tpcompanysize: values?.tpcompanysize,
        tprevenue: values?.tprevenue,
        tprevenuereferenceyear: values?.tprevenuereferenceyear,
        tpidentitycardcountry: values?.tpidentitycardcountry,
        tpidentitycardexpirationdate: dateToString(
          values?.tpidentitycardexpirationdate
        ),
        tpactivitysector: values?.tpactivitysector,
        tpreference: values?.tpreference
        // tpflagconsentmain:values?.tpflagconsentmain,
        // tpflagconsent2:values?.tpflagconsent2,
        // tpflagconsent3:values?.tpflagconsent3,
        // tpflagconsent4:values?.tpflagconsent4,
        // tpflagconsent5:values?.tpflagconsent5,
        //not found in Api ThirdParty
      },
      income: {
        tpemployer: values?.tpemployer,
        tpemployeraddress: values?.tpemployeraddress,
        tpemloyertel: values?.tpemloyertel,
        tpmonthlyincome: values?.tpmonthlyincome,
        tpothersincome: values?.tpothersincome,
        tpfamilybenefits: values?.tpfamilybenefits,
        tpothersexpense: values?.tpothersexpense,
        tpotherloan: values?.tpotherloan,
      },
      role: {
        tpreminderfeesformula: values?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          values?.tpblockreminderfeesinvoicing === undefined
            ? false
            : values?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          values?.tpblockrejectionfeesinvoicing === undefined
            ? false
            : values?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: values?.tprejectionfeesformula,

        tpflagclient: values?.tpflagclient,
        tpflagsupplier: values?.tpflagsupplier,
        tpflagguarantor: values?.tpflagguarantor,
        tproleother: values?.tproleother,
        tppaymodein: values?.tppaymodein,
        tppaydelayin: values?.tppaydelayin,
        tppaymodeout: values?.tppaymodeout,
        tppaydelayout: values?.tppaydelayout,
        tplateinterestformula: values?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          values?.tpblocklateinterestinvoicing === undefined
            ? false
            : values?.tpblocklateinterestinvoicing,
      },
      spouse: {
        spname: values?.spname,
        spsurname: values?.spsurname,
        spgender: values?.spgender,
        spbirthdate: dateToString(values?.spbirthdate),
        spbirthcity: values?.spbirthcity,
        spbirthcountry: values?.spbirthcountry,
        spmaidenname: values?.spmaidenname,
        spsalutationcode: values?.spsalutationcode,
        spfiscalid: values?.spfiscalid,
        spprofession: values?.spprofession,
        spidentitycardtype: values?.spidentitycardtype,
        spidentitycardid: values?.spidentitycardid,
        spemployer: values?.spemployer,
        spemployeraddress: values?.spemployeraddress,
        spemloyertel: values?.spemloyertel,
        spmonthlyincome: values?.spmonthlyincome,
        spothersincome: values?.spothersincome,
        spothersexpense: values?.spothersexpense,
        spotherloan: values?.spotherloan,
      },
    };
  };

  const gettptype = (tp: any) => {
    settptype(tp);
  };
  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
  const onFinish = (e: any) => {
    setLoadingBtn(true);
    form
      .validateFields()
      .then((values) => {
        const tpdData = prepareThirdPartyRequest(values);

        let entityAddAttribut = form.getFieldValue('entityAddAttributList');
        let entityAddAttributList: EntityAdditionalAttributeRequest[] = [];

        if (entityAddAttribut !== undefined) {
          Object.keys(entityAddAttribut).forEach(function (key, index) {
            let attnumericvalue: number = 0;
            let atttextvalue: string = '';
            let attbooleanvalue = null;
            let attstringvalue: string = '';
            if (isBoolean(entityAddAttribut[key])) {
              attbooleanvalue = Boolean(entityAddAttribut[key]);
            } else if (isNumber(entityAddAttribut[key])) {
              attnumericvalue = Number(entityAddAttribut[key]);
            } else if (String(entityAddAttribut[key])?.length < 100) {
              attstringvalue = entityAddAttribut[key];
              //atttextvalue = entityAddAttribut[key];
            } else {
              atttextvalue = entityAddAttribut[key];
            }

            let attdatatype = attlist?.find(
              (attribute: any) => key === attribute.attcode
            );

            let entityAddAttributData: EntityAdditionalAttributeRequest = {
              attbooleanvalue: attbooleanvalue ?? false,
              attcode: key,
              attnumericvalue: attnumericvalue,
              attstringvalue: attstringvalue,
              atttextvalue: atttextvalue,
              entity: '',
              entityid: 0,
              id: 0,
            };

            entityAddAttributList.push(entityAddAttributData);
          });
        }

        let generalData = {
          ...tpdData?.generalData,
          tpbirthdate: dateToString(tpdData?.generalData?.tpbirthdate),
        };

        const dataSave = {
          ...tpdData,
          generalData: generalData,
          entityAddAttributList: entityAddAttributList ?? [],
        };

        if (thirdParty) {
          updateThirdParty({
            ThirdPartyRequest: dataSave,
            tpid: Number(id),
          })
            .then((res) => {
              setLoadingBtn(false);
              if (res.code === '200') {
                notification.success({
                  message: 'ThirdParty updated successfully ',
                });
                //navigate(`/third-party/${res.data.generalData.tpid}/${phase}`);
                thirdParty = res.data;
                refetch();
              } else {
                setLoadingBtn(false);
                notification.warning({
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              setLoadingBtn(false);
            });
        } else {
          if (
            (dataSave.role?.tpflagclient === false ||
              dataSave.role?.tpflagclient === undefined) &&
            (dataSave.role?.tpflagguarantor === false ||
              dataSave.role?.tpflagguarantor === undefined) &&
            (dataSave.role?.tpflagsupplier === false ||
              dataSave.role?.tpflagsupplier === undefined) &&
            (dataSave.role?.tproleother === '' ||
              dataSave.role?.tproleother === undefined)
          ) {
            setLoadingBtn(false);

            if (localStorage.getItem('lancode') === 'FR') {
              notification.error({
                message: 'Veuillez sélectionner un rôle',
              });
            } else {
              notification.error({
                message: 'Please select a Creation Role',
              });
            }

            return;
          }
          createThirdParty({ ThirdPartyRequest: dataSave })
            .then((res) => {
              if (res.code === '200') {
                notification.success({
                  message: 'ThirdParty created successfully  ',
                });
                setLoadingBtn(false);
                isModal && setisvisible();
                isModal && form.resetFields();
                onSelect && onSelect(res.data);
                if (isProposalCreate) {
                  const { tpid, tpname, tpreference } = res.data.generalData;
                  setThirdPartyForProposal &&
                    setThirdPartyForProposal({ tpid, tpname, tpreference });
                  hideThirdPartyModal && hideThirdPartyModal();
                  hideThirdPartySearchModal && hideThirdPartySearchModal();
                } else {
                  console.log("redirect", `/third-party/${res.data.generalData.tpid}/TP/${wizData?.taskidDisplay}`)
                  navigate(
                    `/third-party/${res.data.generalData.tpid}/TP`
                  );
                }
                setLoadingBtn(false);
              } else {
                notification.warning({
                  message: res.message,
                  description: res.description,
                });
                isModal && form.resetFields();
              }
            })
            .catch((err) => {
              setLoadingBtn(false);
            });
        }
      })
      .catch((err) => {
        setLoadingBtn(false);
      });
  };
  const openDrawerSynthes = () => {
    setVisible(true);
  };

  return (
    (<DF.Provider
      pagcode="tpdetail"
      entity="THIRDPARTY"
      entityid={Number(id) || 0}
      additionalAttribute={{
        entity: 'THIRDPARTY',
        entitytype: tptype,
        object: 'THIRDPARTY',
      }}
    >
      <Form
        layout="vertical"
        form={form}
        //initialValues={INITIAL_VALUES}
        onFinishFailed={onFinishFailed}
        onSubmitCapture={onFinish}
      >
        <Row style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 9 }}>
          <Col span={!Number(id) ? 10 : 9}>
            {!showAsModal && !isModal && (
              <ArrowLeftOutlined
                onClick={() => {
                  navigate(`/third-party`);
                }}
                style={{
                  float: 'left',
                  margin: '0px 5px',
                  fontSize: 'larger',
                }}
              />
            )}
            {thirdParty ? (
              <>
                <GetLabel label="ThirdParty" />
                {'  ' +
                  thirdParty?.generalData?.tpreference +
                  ' - ' +
                  thirdParty?.generalData?.tpname +
                  ' ' +
                  String(
                    thirdParty?.generalData?.tpsurname == null
                      ? ''
                      : thirdParty?.generalData?.tpsurname
                  )}
              </>
            ) : (
              <Title level={4} comcode="NewThirdParty"></Title>
            )}
          </Col>
          <Col span={!Number(id) ? 14 : 15}>
            {tabPosition === 'left' ? (
              <Row gutter={2} justify="end">
                <Col>
                  <Button
                    comcode="view360"
                    icon={<IPaymentschedule />}
                    onClick={(e) => setVisible360(true)}
                    style={{ height: 52 }}
                  />
                </Col>
                <Col>
                  <Button
                    comcode="communication"
                    icon={<IMail />}
                    onClick={(e) => setVisibleComm(true)}
                    style={{ height: 52 }}
                  />
                </Col>
                <Col>
                  <Button
                    comcode="Synthesis"
                    icon={<ReadOutlined />}
                    onClick={() => openDrawerSynthes()}
                    style={{ height: 52 }}
                  />
                </Col>
                {(!showAsModal || iscreate) && (
                  <>
                    {Number(id) ? (
                      <Col>
                        <TasksListPopover
                          currcode={
                            form.getFieldValue('currcode') ??
                            thirdParty?.generalData?.currcode
                          }
                          clientName={data?.generalData?.tpname}
                          mgid={thirdParty?.generalData?.mgid}
                          entityId={Number(id)}
                          entityName="THIRDPARTY"
                          entityReference={thirdParty?.generalData?.tpreference}
                          title={
                            thirdParty?.generalData?.tpreference +
                            ' - ' +
                            thirdParty?.generalData?.tpname
                          }
                          onClose={() => {
                            setrefetech(!refetech);
                            refetch();
                          }}
                          formTP={form}
                          countcode={form.getFieldValue('countcode')}
                        >
                          <Button comcode="actionswf" style={{ height: 52 }} icon={<IActions />} />
                        </TasksListPopover>
                      </Col>
                    ) : null}
                    <Col>
                      <SaveButton
                        comcode="save"
                        custom={{ height: 52 }}
                        loading={loadingBtn}
                      />
                    </Col>
                  </>
                )}
              </Row>
            ) : null}
          </Col>
        </Row>
        <WizardTabs
          entity="THIRDPARTY"
          entityid={Number(id) || undefined}
          taskid={
            taskid
              ? taskid
              : id
                ? wizData?.taskidDisplay
                : wizData?.taskidCreate
          }
          defaultTabs={[
            'tabGeneralData',
            'tabAddresses',
            'tabContacts',
            'tabBankAccount',
          ]}
          hiddenTabs={
            id !== undefined
              ? thirdParty?.generalData?.tptype === 'PART'
                ? [
                  'tabFinStatement',
                  'tabGeneralDataSFS',
                  'tabPlafondsandGradingSFS',
                  'TabBkInfoSFS',
                  'tabAddressSFS',
                  'tabcontactsSFS',
                  'AccordSFS',
                ]
                : [
                  'tabIncome',
                  'tabSpouse',
                  'tabGeneralDataSFS',
                  'tabPlafondsandGradingSFS',
                  'TabBkInfoSFS',
                  'tabAddressSFS',
                  'tabcontactsSFS',
                  'AccordSFS',
                ]
              : tptype !== 'PART'
                ? [
                  'tabIncome',
                  'tabSpouse',
                  'tabGeneralDataSFS',
                  'tabPlafondsandGradingSFS',
                  'TabBkInfoSFS',
                  'tabAddressSFS',
                  'tabcontactsSFS',
                  'AccordSFS',
                ]
                : [
                  'tabFinStatement',
                  'tabGeneralDataSFS',
                  'tabPlafondsandGradingSFS',
                  'TabBkInfoSFS',
                  'tabAddressSFS',
                  'tabcontactsSFS',
                  'AccordSFS',
                ]
          }
          tabs={{
            tabCheckList: (
              <DocList
                objectid={Number(id)}
                tpid={Number(id)}
                objecttype="THIRDPARTY"
                objectname={thirdParty?.generalData?.tpname ?? ''}
                objectreference={thirdParty?.generalData?.tpreference ?? ''}
                categorie="CHECK"
                showAsModal={showAsModal}
                refetchProp={isFetching}
              />
            ),
            tabGeneralData: (
              <Spin spinning={isFetching}>
                <GeneralDataCard form={form} tpid={id} gettptype={gettptype} />
              </Spin>
            ),
            tabAddresses: (
              <AddressCard
                form={form}
                id={Number(id)}
                showAsModal={showAsModal}
              />
            ),
            tabContacts: <ContactCard form={form} />,
            tabRoles: (
              <RolesCard
                form={form}
                id={Number(id)}
                showAsModal={showAsModal}
                refetch={refetech}
                refetchTp={() => {
                  refetch();
                }}
                data={data}
              />
            ),
            tabBankAccount: (
              <BankAccountCard
                form={form}
                id={Number(id)}
                showAsModal={showAsModal}
                data={data}
              />
            ),
            tabStatus: <StatusCard id={id} refetchProp={isFetching} />,
            tabCorrespondants: (
              <CorrespondantsCard id={id} refetchTab={isFetching} form={form} />
            ),
            tabProcessFollowup: (
              <TPProcessFollowUp
                refetch={refetech}
                tpid={Number(id)}
                refetchProp={isFetching}
              />
            ),
            tabRelationShipList: (
              <RelationShipListCard
                id={Number(id)}
                showAsModal={showAsModal}
                refetchTab={isFetching}
              />
            ),
            tabAdditionalInfo: <AdditionalInfoCard />,
            tabFinStatement: (
              <FinStatementCard
                objectid={id}
                tpreference={thirdParty?.generalData?.tpreference}
                tpname={thirdParty?.generalData?.tpname}
                form={form}
                showAsModal={showAsModal}
                refetchTab={isFetching}
              />
            ),
            tabTpRating: (
              <CurrentStatusCard id={Number(id)} refetchProp={isFetching} />
            ),
            tabIncome: <IncomeCard form={form} />,
            tabSpouse: <SpouseCard form={form} />,
            tabUpload: (
              <DocList
                objectid={Number(id)}
                objecttype="THIRDPARTY"
                objectname={thirdParty?.generalData?.tpname ?? ''}
                objectreference={thirdParty?.generalData?.tpreference ?? ''}
                tpid={Number(id)}
                hideCol
                categorie="DOC"
                showAsModal={showAsModal}
                refetchProp={isFetching}
              />
            ),
            tabFlows: (
              <Flows
                tpid={id}
                showAsModal={showAsModal}
                form={form}
                currcode={
                  form.getFieldValue('currcode') ??
                  thirdParty?.generalData?.currcode
                }
              />
            ),
            tabTPAuthorization: (
              <TabTPAuthorization
                form={form}
                tpid={Number(id)}
                refetchTab={isFetching}
              />
            ),
          }}
          tabBarExtraContent={
            tabPosition === 'top' ? (
              <>
                <Row gutter={2} justify="end">
                  <TasksListPopover
                    currcode={
                      form.getFieldValue('currcode') ?? thirdParty?.generalData?.currcode}
                    clientName={data?.generalData?.tpname}
                    entityId={Number(id)}
                    entityName="THIRDPARTY"
                    entityReference={thirdParty?.generalData?.tpreference}
                    title={
                      thirdParty?.generalData?.tpreference +
                      ' - ' +
                      thirdParty?.generalData?.tpname
                    }
                    mgid={thirdParty?.generalData.mgid}
                    onClose={() => {
                      setrefetech(!refetech);
                      refetch();
                    }}
                    formTP={form}
                  >
                    <Button comcode="actions" style={{ width: 120, height: 52 }}
                      icon={<IActions />} />
                  </TasksListPopover>

                  <Col span={!Number(id) ? 5 : 4}>
                    <SaveButton
                      comcode="save"
                      custom={{ height: 52 }}
                      loading={loadingBtn}
                    />
                  </Col>

                </Row>
              </>

            ) : null
          }
        />
      </Form>
      <Drawer
        title={<GetLabel label="Communication" />}
        width="80%"
        placement="right"
        onClose={() => setVisibleComm(false)}
        open={visibleComm}
        headerStyle={{ backgroundColor: '#00a896' }}
        bodyStyle={{ paddingBottom: 10, alignContent: 'center' }}
        drawerStyle={{
          padding: '10px 16px 10px 10px',
          margin: '10px 16px 10px 10px',
        }}
      >
        <CommList tpid={Number(id)} />
      </Drawer>
      <Drawer
        title={<GetLabel label="View360" />}
        width="80%"
        placement="right"
        onClose={() => setVisible360(false)}
        open={visible360}
        headerStyle={{ backgroundColor: '#00a896' }}
        bodyStyle={{ paddingBottom: 10, alignContent: 'center' }}
        drawerStyle={{
          padding: '10px 16px 10px 10px',
          margin: '10px 16px 10px 10px',
        }}
      >
        <Flows
          tpid={id}
          showAsModal={showAsModal}
          form={form}
          currcode={
            form.getFieldValue('currcode') ?? thirdParty?.generalData?.currcode
          }
        />
      </Drawer>
      <Drawer
        title={<GetLabel label="SynthesList" />}
        width={500}
        onClose={closeSynthes}
        open={visible}
        destroyOnClose
        headerStyle={{ backgroundColor: '#00a896' }}
        bodyStyle={{ paddingBottom: 80, alignContent: 'center' }}
        drawerStyle={{
          padding: '10px 16px 10px 10px',
          margin: '10px 16px 10px 10px',
        }}
        rootStyle={{ color: '#fff' }}
      >
        <SynthesList
          objecttype="THIRDPARTY"
          objectid={Number(id) || 0}
          currcode={
            form.getFieldValue('currcode') ?? thirdParty?.generalData?.currcode
          }
        />
      </Drawer>
    </DF.Provider>)
  );
};

export default ThirdPartyDetail;
